import { render, staticRenderFns } from "./DashboardBox.vue?vue&type=template&id=35cb4da5&scoped=true"
import script from "./DashboardBox.vue?vue&type=script&lang=js"
export * from "./DashboardBox.vue?vue&type=script&lang=js"
import style0 from "./DashboardBox.vue?vue&type=style&index=0&id=35cb4da5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cb4da5",
  null
  
)

export default component.exports